var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"company-rights"},[_vm._v("Copyright ©"+_vm._s(_vm.year)+" "+_vm._s(_vm.$t('app.company')))]),_c('p',{staticClass:"company-email"},[_vm._v(" "+_vm._s(_vm.$t('app.business'))+"："),_c('a',{attrs:{"href":`mailto:${_vm.contact_email}`,"target":"_blank"}},[_vm._v(_vm._s(_vm.contact_email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }